import axios from 'axios'
export default {
    namespaced: true,

    state: {
        filteredDocuments: [],
        documents: [],
        bookmarkedDocuments: [],
        ingredientsList: [],
        region: 1,
        orderBy: 1,
        searchQuery: '',
        filterValues: []
    },

    getters: {
        getDocuments(state) {
            return state.documents
        },

        getFilteredDocuments(state) {
            return state.filteredDocuments
        },

        getBookmarkedDocuments(state) {
            return state.bookmarkedDocuments
        },
        
        getIngredientsList(state) {
            return state.ingredientsList
        },

        getSearchQuery(state) {
            return state.searchQuery
        },

        getFilterValues(state) {
            return state.filterValues
        },

        getSortOrder(state) {
            return state.orderBy
        },

        getRegion(state) {
            return state.region
        }
    },

    mutations: {
        PUSH_DOCUMENTS(state, data) {
            state.documents = data

            const filteredDocuments = state.documents.filter(document => {
                return document.region === state.region
            })

            state.filteredDocuments = filteredDocuments
        },
        PUSH_FILTERED_DOCUMENTS(state, data) {
            state.filteredDocuments = data
        },
        SET_SEARCH_QUERY(state, data) {
            state.searchQuery = data
        },
        SET_FILTER_VALUES(state, data) {
            state.filterValues = data
        },
        PUSH_BOOKMARKS(state, data) {
            state.bookmarkedDocuments = data
        },
        PUSH_BOOKMARK(state, data) {
            state.bookmarkedDocuments.push(data)
        },
        REMOVE_BOOKMARK(state, data) {
            state.bookmarkedDocuments = state.bookmarkedDocuments.filter(document => {
                return document !== data
            })
        },
        PUSH_INGREDIENTS(state, data) {
            state.ingredientsList = data
        },
        SET_SORT_ORDER(state, data) {
            state.orderBy = data
        },
        SET_REGION(state, data) {
            state.region = data
        }
    },

    actions: {
        async getDocuments({commit}) {
            try {
                const response = await axios.get('Get_Documents/v2')

                commit('PUSH_DOCUMENTS', response.data.documents)

                return response
            } catch(err) {
                throw new Error(err)
            }
        },

        async setFilteredDocuments({commit}, data) {
            commit('PUSH_FILTERED_DOCUMENTS', data)
        },

        async setSearchQuery({commit}, data) {
            commit('SET_SEARCH_QUERY', data)
        },  

        async setFilterValues({commit}, data) {
            commit('SET_FILTER_VALUES', data)
        },

        async setSortOrder({commit}, data) {
            commit('SET_SORT_ORDER', data)
        },

        async setRegion({commit}, data) {
            commit('SET_REGION', data)
        },

        async setBookmarks({commit}, data) {
            commit('PUSH_BOOKMARKS', data)
        }, 

        async removeBookmark({commit}, data) {
            commit('REMOVE_BOOKMARK', data)
        },

        async addBookmark({commit}, data) {
            commit('PUSH_BOOKMARK', data)
        },

        async setIngredients({commit}, data) {
            commit('PUSH_INGREDIENTS', data)
        }
    }
}